import { Component } from 'react'
import { connect } from 'react-redux'
import { message, notification } from 'antd'

import LangContext from 'modules/shared/context/langContext'
import { voiceText } from './labels'

// The gateway and SIP paths can report the same problem at once.
const REPEAT_WINDOW_MS = 10000

// Shows state.voice.notice (set by the saga) with antd message/notification,
// translated through LangContext. Renders nothing itself.
class VoiceNotices extends Component {
  static contextType = LangContext

  last = { text: null, at: 0 }

  componentDidUpdate(prevProps) {
    const { notice } = this.props
    if (!notice) return
    if (prevProps.notice && prevProps.notice.id === notice.id) return

    const i18n = this.context
    const text =
      voiceText(i18n, notice.key) + (notice.detail ? ` (${notice.detail})` : '')
    const now = Date.now()
    if (text === this.last.text && now - this.last.at < REPEAT_WINDOW_MS) return
    this.last = { text, at: now }

    if (notice.hintKey) {
      const open = notification[notice.level] || notification.open
      open({
        message: text,
        description: voiceText(i18n, notice.hintKey),
        duration: 10,
      })
      return
    }
    const show = message[notice.level] || message.info
    show(text, notice.level === 'error' ? 5 : 3)
  }

  render() {
    return null
  }
}

const mapStateToProps = state => ({ notice: state.voice.notice })

export default connect(mapStateToProps)(VoiceNotices)
